import { render } from "./TaskTab.vue?vue&type=template&id=b1ddb138"
import script from "./TaskTab.vue?vue&type=script&lang=js"
export * from "./TaskTab.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__